/* eslint-disable */
/* eslint-enable */
/* eslint eqeqeq: 0, curly: 2 */

import {
  Typography,
  Banner,
  Button,
  Col,
  Form,
  Divider,
  Modal,
  Row,
  Tabs,
  TabPane,
  Toast,
  List,
  Avatar,
  Space,
  Tooltip,
  Popconfirm,
} from "@douyinfe/semi-ui";
import {
  ApiClient,
  getLeadStatusOpt,
  Lead,
  LeadAssignLog,
  LeadContactLog,
  LeadStarLog,
  displayLeadStatus,
  ReadOnlyLeadStatus,
  getSalesLeadStatusOpt,
  Loan,
  displayLoanStatus,
  LeadStatus,
  User,
  ApiResp,
  Page,
  ReadOnlyVisitLeadStatus,
  LoanContactLog,
} from "../../api/ApiClient";
import { AsyncSelect } from "./asyncSelect";
import {
  IconHelpCircle,
  IconAlertTriangle,
  IconUserCardPhone,
  IconArrowRight, IconModalStroked,
} from "@douyinfe/semi-icons";
import React, { useEffect, useState, useRef } from "react";
import "./leadDetail.css";
import { CrudOption } from "../../comp/crud";
import {
  avatarName,
  formatDateTime,
  displayStar,
  StarList,
  formatRelativeTime,
} from "../../utils";
import { FormApi } from "@douyinfe/semi-ui/lib/es/form";
import pubsub from "pubsub-js";

export interface LeadDetailProps {
  viewMode?: boolean;
  visitMode?: boolean;
  leadId?: number;
  leadIds?: number[];
  queryParams?: any;
  onOk?: () => void;
  onCancel?: () => void;
  onSentToPool?: () => void;
  newWindow?: boolean;
}
const Title = Typography.Title;
const apiClient = ApiClient.getDefault();
const {
  TextArea,
  Section,
  Input,
  DatePicker,
  TimePicker,
  Select,
  Switch,
  InputNumber,
  Checkbox,
  CheckboxGroup,
  RadioGroup,
  Radio,
} = Form;
const starHelp = (
  <p style={{ lineHeight: "2em" }}>
    1星：客户是没有可贷点；人在外地（本人不在本地工作者）
    <br />
    2星：有按揭车、全款车、商业保单、企业或则个体户有纳税
    <br />
    3星：外地按揭房、外地全款房、外地公积金
    <br />
    4星：本地有缴纳公积金
    <br />
    5星：本地按揭房、本地全款房、本地回迁房有证
    <br />
    （客户如果是多个条件，则选择最高星级）
  </p>
);
const callPhoneHelp = (
  <p style={{ lineHeight: "2em" }}>
    1：要使用拨号功能 ，请下载APP，使用自己的账号和密码登录
    <br />
    2：若提示手机端不在线，请先登录手机端，若APP连接服务器失败，请点击手动连接按钮
  </p>
);
const contactLogTemplate = [
  "无需贷款",
  "未接电话",
  "客户挂机",
  "客户关机",
  "空号",
  "拨打的用户正忙  请稍后再拨",
  "停机",
];
export function LeadDetail(props: LeadDetailProps) {
  const [leadContactLogs, setLeadContactLogs] = useState(
    [] as LeadContactLog[]
  );
  const [leadContactLogsSelect, setLeadContactLogsSelect] = useState(
    [] as LeadContactLog[]
  );
  const [loanContactLogs, setLoanContactLogs] = useState(
    [] as LoanContactLog[]
  );
  const [leadAssignLogs, setLeadAssignLogs] = useState([] as LeadAssignLog[]);
  const [leadStarLogs, setLeadStarLogs] = useState([] as LeadStarLog[]);
  const [contactLogSaving, setContactLogSaving] = useState(false);
  const [starSaving, setStarSaving] = useState(false);
  const [visitTimeSaving, setVisitTimeSaving] = useState(false);
  const [leadSaving, setLeadSaving] = useState(false);

  const [loans, setLoans] = useState([] as Loan[]);
  const [lead, setLead] = useState(undefined as undefined | Lead);
  const [leadId, setLeadId] = useState<number>();
  const [leadIds, setLeadIds] = useState<number[]>();
  const [userInfoForm, setUserInfoForm] = useState<any>();
  const [statusForm, setStatusForm] = useState<any>();
  const [visitForm, setVisitForm] = useState<any>();
  const [logForm, setLogForm] = useState<any>();
  const [loadingAll, setLoadingAll] = useState(false);
  const [showInfo, setShowInfo] = useState(
    apiClient.getPref<boolean>("userInfo")
  );
  const [showTodo, setShowTodo] = useState(false);
  const [todoFormApi, setTodoFormApi] = useState<any>();
  const [savingTodo, setSavingTodo] = useState(false);
  const [poolSaving, setPoolSaving] = useState(false);
  const [starInfoAll, setStarInfoAll] = useState<CrudOption[]>([]);
  const [starInfo, setStarInfo] = useState<CrudOption[]>([]);
  const formRef = useRef(null);
  const [statusInfoAll, setStatusInfoAll] = useState<CrudOption[]>([]);
  const [statusInfo, setStatusInfo] = useState<CrudOption[]>([]);
  let [admin, setAdmin] = useState<User>();
  const [readOnlyLeadStatus, setReadOnlyLeadStatus] = useState([] as any);
  const [viewMode, setViewMode] = useState(false);
  const [savingFav, setSavingFav] = useState(false);
  const [leadFav, setLeadFav] = useState(false);
  const [savingAssign, setSavingAssign] = useState(false);
  const [visitSignLogText, setVisitSignLogText] = useState("");
  const role = localStorage.getItem("role");


  const loadLead = async () => {
    if (leadId == undefined) {
      return Promise.resolve(undefined);
    }
    let l = await apiClient.getLead(leadId);

    userInfoForm?.setValues(l);
    statusForm?.setValues(l);
    visitForm?.setValues(l);
    logForm?.setValues(l);

    if (props.newWindow) {
      window.document.title = "客户:" + l?.name;
    }
    //加载星级和状态
    let statusOpt = getSalesLeadStatusOpt();
    setStatusInfoAll(statusOpt);

    if (l?.star == 0) {
      setStatusInfo(
        statusOpt.filter((item) => {
          return item.value == "PENDING_CONTACT" || item.value == "UNREACHABLE";
        })
      );

      if (
        String(l.status) != "PENDING_CONTACT" &&
        String(l.status) != "UNREACHABLE"
      ) {
        let newLeadStatus: LeadStatus = "PENDING_CONTACT" as LeadStatus;
        l.status = newLeadStatus;
      }
    } else if (l?.star == 1) {
      setStatusInfo(
        statusOpt.filter((item) => {
          return item.value != "PENDING_CONTACT" && item.value != "UNREACHABLE";
        })
      );

      if (
        String(l.status) == "PENDING_CONTACT" ||
        String(l.status) == "UNREACHABLE"
      ) {
        let newLeadStatus: LeadStatus = "OUT_LEAD" as LeadStatus;
        l.status = newLeadStatus;
      }
    } else {
      setStatusInfo(
        statusOpt.filter((item) => {
          return (
            item.value != "PENDING_CONTACT" &&
            item.value != "UNREACHABLE" &&
            item.value != "OUT_LEAD"
          );
        })
      );
      if (
        String(l.status) == "PENDING_CONTACT" ||
        String(l.status) == "UNREACHABLE" ||
        String(l.status) == "OUT_LEAD"
      ) {
        let newLeadStatus: LeadStatus = "PENDING_VISIT" as LeadStatus;
        l.status = newLeadStatus;
      }
    }

    setLead(l);
    setLeadFav(l.fav);

    let starArr = StarList.map((s) => {
      return {
        label: displayStar(s),
        value: s,
        key: s + "",
      };
    });
    setStarInfoAll(starArr);
    setStarInfo(starArr);
  };

  const loadLeadIds = async () => {
    if (!props.queryParams) {
      return;
    }
    let apiResp: ApiResp<Page<any>> = await apiClient.request(
      "/leadLoans",
      "GET",
      props.queryParams
    );
    let leadIdsLocal = apiResp.data.records.map((v) => v.id);

    return leadIdsLocal;
  };

  const loadLeadContactLogs = () => {
    return apiClient
      .getAllLeadContactLogs(leadId!)
      .then((logs) => setLeadContactLogs(logs));
  };

  const loadAllLeadContactLogsGroupBySaleId = () => {
    return apiClient
      .getLoanTodoUserId(leadId!)
      .then((logs) => setLeadContactLogsSelect(logs));
  };

  const loadLoanContactLogs = () => {
    return apiClient
      .getAllLoanContactLogs(leadId!)
      .then((logs) => setLoanContactLogs(logs));
  };

  const loadLeadAssignLogs = () => {
    apiClient
      .getAllLeadAssignLogs(leadId!)
      .then((logs) => setLeadAssignLogs(logs));
  };

  const loadLeadStarLogs = () => {
    apiClient.getAllLeadStarLogs(leadId!).then((logs) => setLeadStarLogs(logs));
  };

  const loadLeadVisitAssignLogs = () => {
    apiClient.getAllLeadVisitAssignLogs(leadId!).then((logs) => {
      let logText = "";
      logs.forEach((log) => {
        logText = logText + log.saleName + "  " + log.createdAt + "\r\n";
      });
      setVisitSignLogText(logText);
    });
  };



  const loanLeadLoans = () => {
    apiClient.getAllLeadLoans(leadId!).then((l) => setLoans(l));
  };

  const refreshParentLead = () => {
    localStorage.setItem("new-refresh", "true");
    localStorage.setItem("my-refresh", "true");
    localStorage.setItem("fav-refresh", "true");
    localStorage.setItem("team-refresh", "true");
    localStorage.setItem("pool-refresh", "true");
    //  publish 发布消息 消息名为：name 内容为：
    pubsub.publish("refreshMenuCount", "");
  };

  const handleSendToPool = async () => {
    Modal.confirm({
      title: "是否确认要送回公共池?",
      content: "",
      onOk: async () => {
        setPoolSaving(true);
        try {
          await apiClient.request("/leads/pool", "POST", undefined, {
            leadIds: [leadId!],
          });
          Toast.info("已送回公共池");
          props.onSentToPool && props.onSentToPool();
          refreshParentLead();
          setPoolSaving(false);
        } catch (e) {
          setPoolSaving(false);
        }
      },
    });
  };

  const nextLeadId = () => {
    if (!leadIds) {
      return undefined;
    }
    const i = leadIds.indexOf(leadId!);
    return leadIds[i + 1];
  };

  const preLeadId = () => {
    if (!leadIds) {
      return undefined;
    }
    const i = leadIds.indexOf(leadId!);
    return leadIds[i - 1];
  };

  const handleNextClick = async () => {
    if (!props.queryParams) {
      return;
    }
    let nextId = nextLeadId();
    if (!nextId) {
      props.queryParams.page = parseInt(props.queryParams.page) + 1;
      let leadIdsLocal = await loadLeadIds();
      setLeadIds(leadIdsLocal);
      if (leadIdsLocal && leadIdsLocal.length > 0) {
        nextId = leadIdsLocal[0];
      } else {
        Toast.warning("没有下一条");
        return;
      }
    }
    setLeadId(nextId);
    //loadAll();
  };

  const handlePrevClick = async () => {
    if (!props.queryParams) {
      return;
    }
    let preId = preLeadId();
    if (!preId) {
      if (props.queryParams.page == 1) {
        Toast.warning("没有上一条");
        return;
      }
      props.queryParams.page = parseInt(props.queryParams.page) - 1;
      let leadIdsLocal = await loadLeadIds();
      setLeadIds(leadIdsLocal);
      if (leadIdsLocal && leadIdsLocal.length > 0) {
        preId = leadIdsLocal[leadIdsLocal.length - 1];
      } else {
        Toast.warning("没有上一条");
        return;
      }
    }
    setLeadId(preId);
    //loadAll();
  };

  const loadAll = async () => {
    if (!leadId) {
      console.log("没有leadId");
      return;
    }
    setLoadingAll(true);
    try {
      await loadLead();
      //loadLeadContactLogs();
      //loadAllLeadContactLogsGroupBySaleId();
      loadLoanContactLogs();
      //loadLeadAssignLogs();
      loadLeadStarLogs();
      loadLeadVisitAssignLogs();
      //loanLeadLoans();
      setLoadingAll(false);
    } catch (e) {
      setLoadingAll(false);
    }
  };

  useEffect(() => {
    //setViewMode(props.viewMode!=undefined&&props.viewMode?true:false);
    setLeadId(props.leadId);

    loadLeadIds().then((data) => setLeadIds(data));
  }, [props.leadId]);

  useEffect(() => {
    if (props.visitMode) {
      setReadOnlyLeadStatus(ReadOnlyVisitLeadStatus);
    } else {
      setReadOnlyLeadStatus(ReadOnlyLeadStatus);
    }

    if (leadId) {
      loadAll();
    } else {
      setLead(undefined);
    }
  }, [leadId]);

  const handleToggleUserInfo = () => {
    const result = !showInfo;
    setShowInfo(result);
    apiClient.putPref("userInfo", result);
  };
  const handleTodoSubmit = async () => {
    await todoFormApi!.validate();
    const values = todoFormApi!.getValues();
    const content = values["content"];
    const userId = values["userId"];
    const dueDate = formatDateTime(values["dueDate"]);
    setSavingTodo(true);
    try {
      await apiClient.request("/leadLoans/createLeadLoanTodo", "POST", undefined, {
        leadId: leadId,
        content: content,
        dueDate: dueDate,
        userId: userId,
      });
      setSavingTodo(false);
      todoFormApi?.reset();
      setShowTodo(false);
      Toast.info("提醒信息已保存");
      loadLoanContactLogs();
    } catch (e) {
      setSavingTodo(false);
    }
  };
  const rules = [{ required: true, message: "请填写" }];
  return !lead ? null : (
    <div>
      <Modal
          icon={<IconModalStroked size={"extra-large"} style={{ color: 'blue' }}/>}
        title="新建提醒"
        visible={showTodo}
        onCancel={() => setShowTodo(false)}
        onOk={handleTodoSubmit}
        confirmLoading={savingTodo}
      >
        <Form getFormApi={(api) => setTodoFormApi(api)}>
          {/* <Form.Select
            rules={[{ required: true, message: "请填写" }]}
            initValue={leadContactLogsSelect[0].saleId}
            style={{ width: "100%" }}
            disabled
            field="userId"
            label="提醒人"
          >
            {leadContactLogsSelect.map((l) => (
              <Form.Select.Option key={l.saleId + ""} value={l.saleId} >
                {l.saleName}
              </Form.Select.Option>
            ))}
          </Form.Select> */}
          <Form.TextArea
            rules={rules}
            placeholder="提醒内容"
            rows={6}
            noLabel
            field="content"
          />
          {/* <Form.DatePicker
            placeholder={"到期时间"}
            type="dateTime"
            noLabel
            field="dueDate"
          /> */}
        </Form>
      </Modal>
      <Modal
          icon={<IconModalStroked size={"extra-large"} style={{ color: 'blue' }}/>}
        className="lead-detail"
        footer={<div></div>}
        fullScreen
        visible={props.leadId != undefined}
        onOk={props.onOk}
        onCancel={props.onCancel}
        closeOnEsc={true}
      >
        <Row gutter={15}>
          <Col span={9}>
            <Form<Lead>
              getFormApi={(api) => setUserInfoForm(api)}
              labelAlign="right"
              labelWidth={100}
              labelPosition="left"
              initValues={lead}
              render={(form) => {
                const handleSubmit = async () => {
                  setLeadSaving(true);
                  try {
                    form.formApi.validate();
                    await apiClient.request(
                      "/leads",
                      "PUT",
                      undefined,
                      form.formApi.getValues()
                    );
                    setLeadSaving(false);
                    Toast.info("客户信息已保存");
                    refreshParentLead();
                  } catch (e) {
                    setLeadSaving(false);
                  }
                };

                return (
                  <>
                    <Section text={"客户信息"}>
                      <Row gutter={10}>
                        <Col span={12}>
                          <Input disabled field="id" label="ID" />
                        </Col>
                        <Col span={12}>
                          <Input disabled field="leadNo" label="编号" />
                        </Col>
                      </Row>
                      <Row gutter={10}>
                        <Col span={12}>
                          <Input disabled field="name" label="姓名" />
                        </Col>
                        <Col span={12}>
                          <AsyncSelect disabled
                            options={() => apiClient.getDictAsOpts("gender")}
                            field="gender"
                            label="性别"
                          />
                        </Col>
                      </Row>
                      <Row gutter={10}>
                        <Col span={12}>
                          <InputNumber disabled
                            style={{ width: "100%" }}
                            field="age"
                            label="年龄"
                          />
                        </Col>
                        <Col span={12}>
                          <AsyncSelect disabled
                            options={() => apiClient.getDictAsOpts("marriage")}
                            field="marriage"
                            label="婚姻"
                          />
                        </Col>
                      </Row>
                      {/* <Row gutter={10}>
                         <Col span={12}>
                          <Input disabled field="source" label="来源" />
                        </Col>
                        <Col span={12}>
                          <AsyncSelect disabled
                            options={() => apiClient.getDictAsOpts("loanType")}
                            field="loanType"
                            label="贷款类型"
                          />
                        </Col>
                      </Row> */}
                      <Row gutter={10}>
                        <Col span={12}>
                          <AsyncSelect disabled
                            options={() => apiClient.getDictAsOpts("city")}
                            field="applyCity"
                            label="申请城市"
                          />
                        </Col>
                        <Col span={12}>
                          <InputNumber disabled
                            style={{ width: "100%" }}
                            field="applyAmount"
                            label="申请额度"
                            suffix="元"
                          />
                        </Col>
                      </Row>
                    </Section>

                    {showInfo ? (
                      <div>
                        <Row gutter={10}>
                          <Col span={12}>
                            <AsyncSelect disabled
                              options={() => apiClient.getDictAsOpts("job")}
                              field="job"
                              label="工作"
                            />
                          </Col>
                          <Col span={12}>
                            <AsyncSelect disabled
                              options={() => apiClient.getDictAsOpts("vehicle")}
                              field="vehicle"
                              label="车产"
                            />
                          </Col>
                        </Row>
                        <Row gutter={10}>
                          <Col span={12}>
                            <AsyncSelect disabled
                              options={() => apiClient.getDictAsOpts("house")}
                              field="house"
                              label="房产"
                            />
                          </Col>
                          <Col span={12}>
                            <AsyncSelect disabled
                              options={() =>
                                apiClient.getDictAsOpts("assurance")
                              }
                              field="assurance"
                              label="保单"
                            />
                          </Col>
                        </Row>
                        <Row gutter={10}>
                          <Col span={12}>
                            <AsyncSelect disabled
                              options={() =>
                                apiClient.getDictAsOpts("providentFund")
                              }
                              field="providentFund"
                              label="公积金"
                            />
                          </Col>
                          <Col span={12}>
                            <AsyncSelect disabled
                              options={() =>
                                apiClient.getDictAsOpts("socialSecurity")
                              }
                              field="socialSecurity"
                              label="社保"
                            />
                          </Col>
                        </Row>
                        <Row gutter={10}>
                          <Col span={12}>
                            <AsyncSelect disabled
                              options={() => apiClient.getDictAsOpts("company")}
                              field="company"
                              label="公司"
                            />
                          </Col>
                          <Col span={12}>
                            <AsyncSelect disabled
                              options={() => apiClient.getDictAsOpts("credit")}
                              field="credit"
                              label="信用"
                            />
                          </Col>
                        </Row>
                        <Row gutter={10}>
                          <Col span={12}>
                            <AsyncSelect disabled
                              options={() =>
                                apiClient.getDictAsOpts("workYears")
                              }
                              field="workYears"
                              label="工作年限"
                            />
                          </Col>
                          <Col span={12}>
                            <AsyncSelect disabled
                              options={() => apiClient.getDictAsOpts("income")}
                              field="income"
                              label="收入"
                            />
                          </Col>
                        </Row>

                        <Row gutter={10}>
                          <Col span={24}>
                            <Input disabled
                                   field="companyName"
                                   label="公司名称"
                            />
                          </Col>
                        </Row>
                        <Row gutter={10}>
                          <Col span={12}>
                            <DatePicker disabled
                                        type="date"
                                        field="settledLoanAt"
                                        label="释放日期"

                            />
                          </Col>
                          <Col span={12}>
                            <Input disabled
                                field="loanPoint"
                                label="签约点位"
                            />
                          </Col>
                        </Row>
                        <Row gutter={10}>
                          <Col span={12}>
                            <Input disabled
                                field="salaryBankName"
                                label="代发银行"
                            />
                          </Col>
                          <Col span={12}>
                            <Input disabled
                                field="salary"
                                label="代发工资"
                            />
                          </Col>
                        </Row>
                        <Row gutter={10}>
                          <Col span={12}>
                            <Input disabled
                                field="providentFundBasic"
                                label="公积金基数"
                            />
                          </Col>
                          <Col span={12}>
                            <Input disabled
                                field="education"
                                label="学历"
                            />
                          </Col>
                        </Row>
                        <Row gutter={10}>
                          <Col span={24}>
                            <Input disabled
                                field="whiteBankName"
                                label="白名单"
                            />
                          </Col>
                        </Row>

                      </div>
                    ) : null}

                    <Row>
                      <Col span={24}>
                        <TextArea disabled autosize field="remark" label="资质描述" />
                      </Col>
                    </Row>
                    <Form.Slot>
                      <Space>
                        {/* {!props.viewMode && (
                          <Button
                            onClick={handleSubmit}
                            loading={leadSaving || loadingAll}
                          >
                            保存客户信息
                          </Button>
                        )} */}
                        <Button onClick={handleToggleUserInfo}>
                          {showInfo ? "隐藏更多用户信息" : "显示更多用户信息"}
                        </Button>
                      </Space>
                    </Form.Slot>
                  </>
                );
              }}
            />
          </Col>
          <Col span={9}>
            <Section text={"客户跟进"}>
              <Form<Lead>
                ref={formRef}
                getFormApi={(api) => setStatusForm(api)}
                labelAlign="right"
                labelWidth={100}
                labelPosition="left"
                initValues={lead}
                render={(form) => {
                  const handleSubmit = async () => {
                    setStarSaving(true);
                    try {
                      await form.formApi.validate();
                      const est:any = form.formApi.getValue("estVisitTime");
                      const signedContractAt:any =
                        form.formApi.getValue("signedContractAt");
                      console.log("状态", form.formApi.getValue("status"));
                      await apiClient.request(
                        "/leads/status",
                        "PUT",
                        undefined,
                        {
                          id: leadId,
                          star: form.formApi.getValue("star"),
                          status: form.formApi.getValue("status"),
                          estVisitTime:
                            typeof est == "string"
                              ? est
                              : formatDateTime(
                                est
                              ),

                          signedContractAt:
                            typeof signedContractAt == "string"
                              ? signedContractAt
                              : formatDateTime(
                                signedContractAt
                              ),
                        }
                      );
                      Toast.info("星级状态信息已保存");
                      refreshParentLead();
                      setStarSaving(false);
                      loadLeadStarLogs();
                    } catch (e) {
                      setStarSaving(false);
                    }
                  };

                  const starChangeEvent = (value: any) => {
                    //0星 未处理、待跟进
                    if (value == 0) {
                      setStatusInfo(
                        statusInfoAll.filter((item) => {
                          return (
                            item.value == "PENDING_CONTACT" ||
                            item.value == "UNREACHABLE"
                          );
                        })
                      );
                      const currStatus:any = form.formApi.getValue("status");

                      if (
                        currStatus != "PENDING_CONTACT" &&
                        currStatus != "UNREACHABLE"
                      ) {
                        form.formApi.setValue("status", "PENDING_CONTACT");
                      }
                    } else if (value == 1) {
                      setStatusInfo(
                        statusInfoAll.filter((item) => {
                          return (
                            item.value != "PENDING_CONTACT" &&
                            item.value != "UNREACHABLE"
                          );
                        })
                      );
                      const currStatus:any = form.formApi.getValue("status");

                      if (
                        currStatus == "PENDING_CONTACT" ||
                        currStatus == "UNREACHABLE"
                      ) {
                        form.formApi.setValue("status", "OUT_LEAD");
                      }
                    } else {
                      setStatusInfo(
                        statusInfoAll.filter((item) => {
                          return (
                            item.value != "PENDING_CONTACT" &&
                            item.value != "UNREACHABLE" &&
                            item.value != "OUT_LEAD"
                          );
                        })
                      );
                      const currStatus:any = form.formApi.getValue("status");
                      if (
                        currStatus == "PENDING_CONTACT" ||
                        currStatus == "UNREACHABLE" ||
                        currStatus == "OUT_LEAD"
                      ) {
                        form.formApi.setValue("status", "PENDING_VISIT");
                      }
                    }
                  };

                  const statusChangeEvent = (value: any) => {
                    //外地客户
                    if (value == "OUT_LEAD") {
                      setStarInfo(
                        starInfoAll.filter((item: any) => {
                          return item.value == 1;
                        })
                      );

                      form.formApi.setValue("star", 1);

                      return;
                    } else if (value == "VISITED") {
                      //form.formApi.setValue("actVisitTimeNew", new Date());
                    } else if (value == "SIGNED_CONTRACT") {
                      if (!lead.signedContractAt) {
                        form.formApi.setValue("signedContractAt", new Date());
                      }
                    }

                    setStarInfo(starInfoAll);
                  };

                  const handleFavClick = async () => {
                    if (savingFav) {
                      return;
                    }
                    Modal.confirm({
                      title: "是否确认设置为重要客户?",
                      content: "",
                      onOk: async () => {
                        setSavingFav(true);
                        try {
                          await apiClient.request(
                            "/leads/fav",
                            "POST",
                            undefined,
                            {
                              leadId: lead?.id,
                              fav: true,
                            }
                          );
                          Toast.info("已标记为重要客户");
                          setSavingFav(false);
                          setLeadFav(true);

                          //  publish 发布消息 消息名为：name 内容为：
                          pubsub.publish("refreshMenuCount", "");

                          localStorage.setItem("new-refresh", "true");
                          localStorage.setItem("my-refresh", "true");
                        } catch (e) {
                          setSavingFav(false);
                        }
                      },
                    });
                  };

                  const handleUnFavClick = async () => {
                    if (savingFav) {
                      return;
                    }
                    Modal.confirm({
                      title: "是否确认设置为普通客户?",
                      content: "",
                      onOk: async () => {
                        setSavingFav(true);
                        try {
                          await apiClient.request(
                            "/leads/fav",
                            "POST",
                            undefined,
                            {
                              leadId: lead?.id,
                              fav: false,
                            }
                          );
                          Toast.info("已取消标记为重要客户");
                          setSavingFav(false);
                          setLeadFav(false);

                          //  publish 发布消息 消息名为：name 内容为：
                          pubsub.publish("refreshMenuCount", "");

                          localStorage.setItem("fav-refresh", "true");
                        } catch (e) {
                          setSavingFav(false);
                        }
                      },
                    });
                  };

                  const handleAssignClick = async () => {
                    if (savingAssign) {
                      return;
                    }
                    Modal.confirm({
                      title: "是否确认添加到我的按揭?",
                      content: "",
                      onOk: async () => {
                        setSavingAssign(true);
                        try {
                          await apiClient.request(
                            "/leadLoans/claim",
                            "POST",
                            undefined,
                            {
                              leadIds: [lead?.id],
                            }
                          );
                          Toast.info("已添加到我的按揭");
                          setSavingAssign(false);

                          //我的按揭需要刷新
                          localStorage.setItem("my-loan-refresh", "true");
                          //  publish 发布消息 消息名为：name 内容为：
                          pubsub.publish("refreshMenuCount", "");
                        } catch (e) {
                          setSavingAssign(false);
                        }
                      },
                    });
                  };

                  return (
                    <>
                      {/* <Row>
                        <Col span={24}>
                          <Banner
                            style={{ marginTop: 12 }}
                            fullMode={false}
                            type="warning"
                            bordered
                            icon={<IconAlertTriangle />}
                            title={
                              <div
                                style={{
                                  fontWeight: 600,
                                  fontSize: "14px",
                                  lineHeight: "20px",
                                }}
                              >
                                请按实际情况更新客户星级和状态
                              </div>
                            }
                            description={
                              <div>非常重要！以此作为回流规则重要判断。</div>
                            }
                          />
                        </Col>
                      </Row> */}
                      <Row>
                        <Col span={12}>
                          <Form.Select disabled
                            field="star"
                            label={{
                              text: "星级",
                              extra: (
                                <Tooltip
                                  style={{ maxWidth: 400 }}
                                  content={starHelp}
                                >
                                  <IconHelpCircle
                                    style={{
                                      color: "#E91E63",
                                    }}
                                  />
                                </Tooltip>
                              ),
                            }}
                            onChange={starChangeEvent}
                          >
                            {starInfo.map((pro) => (
                              <Select.Option value={pro.value} key={pro.value}>
                                {pro.label}
                              </Select.Option>
                            ))}
                          </Form.Select>
                        </Col>
                        <Col span={12}>
                          <Form.Select disabled
                            field="status"
                            label="状态"
                            // disabled={readOnlyLeadStatus.includes(
                            //   displayLeadStatus(lead.status)
                            // )}
                            onChange={statusChangeEvent}
                          >
                            {statusInfo.map((pro) => (
                              <Select.Option
                                value={pro.value}
                                key={pro.value}
                                disabled={readOnlyLeadStatus.includes(
                                  displayLeadStatus(pro.value)
                                )}
                              >
                                {pro.label}
                              </Select.Option>
                            ))}
                          </Form.Select>
                        </Col>

                        <Col span={12}>
                          <Form.DatePicker disabled
                            type="dateTime"
                            style={{ width: "100%" }}
                            field="estVisitTime"
                            label="预计上门"
                          />
                        </Col>
                        <Col span={12}>
                          <Form.DatePicker disabled
                            type="dateTime"
                            style={{ width: "100%" }}
                            field="actVisitTimeNew"
                            label={{
                              text: "实际上门",
                              extra: (
                                <Tooltip
                                  style={{
                                    maxWidth: 400,
                                    wordBreak: "break-all",
                                    whiteSpace: "pre-wrap",
                                  }}
                                  content={visitSignLogText}
                                >
                                  <IconHelpCircle
                                    style={{
                                      color: "#E91E63",
                                    }}
                                  />
                                </Tooltip>
                              ),
                            }}
                          />
                        </Col>
                        <Col span={12}>
                          <Form.DatePicker disabled
                            type="dateTime"
                            style={{ width: "100%" }}
                            field="signedContractAt"
                            label="签约时间"
                          />
                        </Col>

                       
                          <Col span={24}>
                            <Form.Slot>
                              <Space>
                                {/* <Button
                                  onClick={handleSubmit}
                                  loading={starSaving || loadingAll}
                                >
                                  保存星级和状态
                                </Button> */}
                                 {(!props.viewMode || props.visitMode) && (
                                <Button onClick={() => setShowTodo(true)}>
                                  新建按揭提醒
                                </Button>
                                 )}
                                {(role == "agent" || role == "agent_manager" ) && (
                                  <Button loading={savingAssign} onClick={handleAssignClick}>
                                    添加到我的按揭
                                  </Button>
                                )}
                                {/* <Button onClick={handleSendToPool}>
                                  送回公共池
                                </Button>
                                {!leadFav && (
                                  <Button onClick={handleFavClick}>
                                    设为重要客户
                                  </Button>
                                )}
                                {leadFav && (
                                  <Button onClick={handleUnFavClick}>
                                    取消重要客户
                                  </Button>
                                )} */}
                              </Space>
                            </Form.Slot>
                          </Col>
                       
                      </Row>
                    </>
                  );
                }}
              />
            </Section>

            <Divider />
            <Form<Lead>
              getFormApi={(api) => setLogForm(api)}
              labelAlign="right"
              labelWidth={100}
              labelPosition="left"
              initValues={lead}
              render={(form) => {
                const handleSubmit = async () => {
                  setContactLogSaving(true);
                  try {
                    await form.formApi.validate();
                    await apiClient.request(
                      "/leads/contactLog",
                      "POST",
                      undefined,
                      {
                        leadId: leadId,
                        content: form.formApi.getValue("content"),
                      }
                    );
                    loadLeadContactLogs();
                    form.formApi.reset();
                    Toast.info("跟进记录已保存");
                    refreshParentLead();
                    setContactLogSaving(false);
                  } catch (e) {
                    setContactLogSaving(false);
                  }
                };
                const handleCallPhone = async () => {
                  setContactLogSaving(true);
                  try {
                    await apiClient.request("/leadCallLog", "POST", undefined, {
                      leadId: leadId,
                    });

                    Toast.info("拨号成功");

                    setContactLogSaving(false);
                  } catch (e) {
                    setContactLogSaving(false);
                  }
                };
                return (
                  <>
                    <Row>
                      <Col span={24}>
                        <Form.Slot>
                          <Title heading={2}>
                            {lead?.name}  {(role == "root" || role == "op_manager" || role == "quzhang") && lead?.fullMobile}
                            {/* 
                            {true && (
                              <>
                                <Button
                                  onClick={handleCallPhone}
                                  icon={<IconUserCardPhone />}
                                  type="danger"
                                  theme="light"
                                  style={{
                                    marginRight: 10,
                                    marginLeft: 20,
                                    marginBottom: 5,
                                  }}
                                >
                                  拨号
                                </Button>

                                <Tooltip
                                  style={{ maxWidth: 400 }}
                                  content={callPhoneHelp}
                                >
                                  <IconHelpCircle
                                    style={{
                                      color: "#E91E63",
                                    }}
                                  />
                                </Tooltip>
                              </>
                            )} */}
                          </Title>
                        </Form.Slot>
                        {/* <Form.TextArea
                          autoFocus
                          style={{ width: "100%" }}
                          rules={[{ required: true, message: "请填写" }]}
                          field="content"
                          label="跟进记录"
                        />
                        <Form.Slot>
                          <Space wrap>
                            {contactLogTemplate.map((t) => (
                              <Button
                                size="small"
                                key={t}
                                onClick={() =>
                                  form.formApi.setValue("content", t)
                                }
                                type="tertiary"
                              >
                                {t}
                              </Button>
                            ))}
                          </Space>
                        </Form.Slot> */}
                      </Col>
                    </Row>

                    <Form.Slot>
                      <Space>
                        {/* <Button
                            onClick={handleSubmit}
                            loading={contactLogSaving || loadingAll}
                          >
                            新增跟进记录
                          </Button> */}
                        <Button
                          loading={loadingAll}
                          onClick={handlePrevClick}
                        >
                          上一条
                        </Button>
                        <Button
                          loading={loadingAll}
                          onClick={handleNextClick}
                        >
                          下一条
                        </Button>
                      </Space>
                    </Form.Slot>

                  </>
                );
              }}
            />
          </Col>
          <Col span={6}>
            <Tabs type="line" defaultActiveKey="loanContactLogs">
              {/* <TabPane tab="跟进记录" itemKey="contactLogs">
                <List<LeadContactLog>
                  dataSource={leadContactLogs}
                  style={{ overflowY: "auto", height: 800 }}
                  renderItem={(l) => (
                    <List.Item
                      main={
                        <div>
                          <span
                            style={{
                              color: "var(--semi-color-text-0)",
                              fontWeight: 500,
                            }}
                          >
                            {l.saleName +
                              "  " +
                              formatRelativeTime(l.createdAt)}
                          </span>
                          <p
                            style={{
                              color: "var(--semi-color-text-2)",
                              margin: "4px 0",
                            }}
                          >
                            {l.content}
                          </p>
                        </div>
                      }
                    />
                  )}
                />
              </TabPane> */}
              <TabPane tab="星级状态记录" itemKey="starLogs">
                <List<LeadStarLog>
                  dataSource={leadStarLogs}
                  style={{ overflowY: "auto", height: 800 }}
                  renderItem={(l) => (
                    <List.Item
                      main={
                        <div>
                          <span
                            style={{
                              color: "var(--semi-color-text-0)",
                              fontWeight: 500,
                            }}
                          >
                            {l.saleName +
                              "  " +
                              formatRelativeTime(l.createdAt)}
                          </span>
                          <p>
                            {displayStar(l.star)} {displayLeadStatus(l.status)}
                          </p>
                        </div>
                      }
                    />
                  )}
                />
              </TabPane>
              {/* <TabPane tab="分配记录" itemKey="assignLogs">
                <List<LeadAssignLog>
                  dataSource={leadAssignLogs}
                  style={{ overflowY: "auto", height: 800 }}
                  renderItem={(l: LeadAssignLog) => (
                    <List.Item
                      main={
                        <div>
                          <span
                            style={{
                              color: "var(--semi-color-text-0)",
                              fontWeight: 500,
                            }}
                          >
                            {l.saleName +
                              "  " +
                              formatRelativeTime(l.createdAt)}
                          </span>
                          <p>
                            分配者：
                            <span style={{ fontWeight: 500 }}>
                              {l.assignBy}
                            </span>{" "}
                            {l.remark}
                          </p>
                        </div>
                      }
                    />
                  )}
                />
              </TabPane> */}
              <TabPane tab="按揭信息" itemKey="loanContactLogs">
                <List<LoanContactLog>
                  dataSource={loanContactLogs}
                  style={{ overflowY: "auto", height: 800 }}
                  renderItem={(l) => (
                    <List.Item
                      style={l.todoType == "QUESTION" ? { color: "#303133" } : { color: "#409EFF" }}
                      header={
                        <Avatar  color={l.todoType == "QUESTION" ? "green" : "blue"}>
                          <span style={{fontSize:14,padding: 4}}>
                            {avatarName(l.createdByName)}
                          </span>

                        </Avatar>
                      }
                      main={
                        <div>
                          <span style={{ color: 'var(--semi-color-text-0)', fontWeight: 500 }} >
                          {formatRelativeTime(l.createdAt)}
                            
                          </span>
                          <p style={{
                            color: 'var(--semi-color-text-2)',
                            margin: '4px 0',
                          }}>
                            @{l.userName}：{l.content}
                          </p>
                          
                        </div>
                      }
                      
                    />
                  )}
                />
              </TabPane>
            </Tabs>
          </Col>
        </Row>
      </Modal>
    </div>
  );
}
